import React, { useState } from "react";
import { useSelector } from "react-redux";
import classNames from "classnames";

import axios from "helpers/_axios";
import ReactContextMenu from "./ContextMenu";
import LoadMore from "./LoadMore";
import Icon from "./Icon";
import Translate from "helpers/Translate";
import Spinner from "assets/img/spinner_black.svg";

function ChildNodes(props) {
  const LIMIT = 10;

  const selectedFile = useSelector(state => state.file.getFile);

  const { item, fileStatus, selectedClient, handleOnItemSelected } = props;
  const [loading, setLoading] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const [childrenData, setChildrenData] = useState([]);
  const [childrenMetadata, setChildrenMetadata] = useState({
    has_more: false
  });
  const [parameters, setParameters] = useState({
    client_id: selectedClient.id,
    department_item_value: selectedClient.department_item_value,
    status: fileStatus ?? fileStatus.join(","),
    materialized_path: item.materialized_path,
    limit: LIMIT
  });

  const fetchChildren = async folderParams => {
    try {
      setLoading(true);
      const result = await axios().get(`/files/tree`, {
        params: folderParams || parameters
      });
      setChildrenData(result.data.data);
      setChildrenMetadata(result.data.meta);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const handleOnNodeClick = file => {
    handleOnItemSelected(file);
  };

  if (!item?.files?.length) {
    return (
      <div className="item center mt-20">
        {Translate({
          id: "no_documents_found"
        })}
      </div>
    );
  }

  return (
    <div>
      <div className="batch-path pointer">
        <i className="fas fa-layer-group mr-5 mb-10"></i>
        {item.files[0]?.parent_path}
        {item.files[0]?.batch_name} (
        {Translate({
          id: "total_of_files",
          values: [item.files.length, item.count]
        })}
        )
      </div>

      <div className="batch-files ml-10">
        {item.files.map(file => (
          <div
            key={file.id}
            className={classNames("child-node pl-10 mb-20", {
              "file-selected": selectedFile && selectedFile.id === file.id
            })}
            onClick={e => {
              e.stopPropagation();
              handleOnNodeClick(file);
            }}
          >
            <ReactContextMenu
              id={file.id}
              item={file}
              // handleFileDelete={handleFileDelete}
              // handleFileRename={handleFileRename}
              // handleFileMoveToNew={handleFileMoveToNew}
              // handleShowItemInFolder={handleShowItemInFolder}
            >
              {loading && (
                <img
                  src={Spinner}
                  width="10px"
                  alt={Translate({ id: "loading" })}
                />
              )}
              <Icon item={file} isOpen={isOpen} setIsOpen={setIsOpen} />
              <div className="item-folder ml-20 mt-5 pointer">
                <i className="fas fa-folder folder mr-5"></i>
                {file.parent_path}
              </div>
            </ReactContextMenu>

            {/* Nested Subfolder */}
            {isOpen &&
              childrenData?.length > 0 &&
              childrenData?.map(child => (
                <ChildNodes key={child.id} {...props} item={child} />
              ))}

            {/* Load More Folders... (pagination) */}
            {loading === false && isOpen && childrenData?.length > 0 && (
              <LoadMore
                childrenMetadata={childrenMetadata}
                setParameters={setParameters}
                fetchChildren={fetchChildren}
                LIMIT={LIMIT}
              />
            )}
          </div>
        ))}
      </div>
    </div>
  );
}

export default ChildNodes;
